<template>
	<div class="product">
		<el-card class="box-card" shadow="hover">
			<el-row :gutter="10">
				<el-col :span="18">
					<el-input placeholder="请输入资源名称关键字(模糊检索)" v-model="searchName" class="input-with-select">
						<el-select placeholder="请选择产品" slot="prepend" v-model="productID" @change="modelcategoryID=''">

							<el-option v-for="item in showProduct()" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select style="margin-left: 30px;" placeholder="请选择模块分类" v-model="modelcategoryID"
							slot="prepend">
							<el-option v-for="item in showProductModelCategory(productID)" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-input>
				</el-col>
			</el-row>
		</el-card>
		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>产品模块列表</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="AddBtn()">新增产品模块
				</el-button>
			</div>
			<el-table :data="showDate()" style="width: 100%;margin-bottom: 20px;">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="categoryID" label="缩略图" width="160">
					<template slot-scope="scope">
						<el-image :src="$http.fileUrl+scope.row.img" style="height: 100px;width: 100%;"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="modelName" label="模块名称">
					<template slot-scope="scope">
						<div
							v-html="scope.row.modelName.replace(searchName,'<font  color=\'red\'>'+searchName+'</font>')">
						</div>
					</template>
				</el-table-column>
				<el-table-column label="所属产品">
					<template slot-scope="scope">
						{{showProductName(scope.row.productID)}}
					</template>
				</el-table-column>
				<el-table-column label="分类名称" width="120">
					<template slot-scope="scope">
						{{showProductModelCategoryName(scope.row.model_CategoryID)}}
					</template>
				</el-table-column>
				
				<el-table-column prop="sceneName" label="场景名称">
				</el-table-column>
				<el-table-column label="使用模式" width="100">
					<template slot-scope="scope">
						{{scope.row.isAssessment?'实训 & 考核':'实训'}}
					</template>
				</el-table-column>
				<el-table-column label="学情分析" width="100">
					<template slot-scope="scope">
						{{scope.row.isAnalysis?'开放':'--'}}
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160">
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button size="mini" style="margin-right: 10px;" icon="el-icon-edit" @click="edit(scope.row)">
							编辑</el-button>&nbsp;
						<el-popconfirm title="确定要删除吗" @confirm="del(scope.row.id)">
							<el-button size="mini" type="danger" icon="el-icon-delete" slot="reference">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<el-dialog :title="dialogType=='Add'?'新增模块':'编辑模块'" :visible.sync="outerVisible">
			<el-form :model="dialogModels" label-width="120px">
				<el-form-item label="模块名称">
					<el-input v-model="dialogModels.modelName"></el-input>
				</el-form-item>
				<el-form-item label="缩略图">
					<vue-cropper2 @upfile="upicon" :defaultIcon="dialogModels.img" :width="380" :height="214"
						style="margin-left: 14px;" path="ProductImg">
					</vue-cropper2>
				</el-form-item>
				<el-form-item label="所属产品">
					<el-select placeholder="请选择" v-model="dialogModels.productID">
						<el-option label="全部产品" value="">
						</el-option>
						<el-option v-for="item in productList" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模块分类(可空)">
					<el-select placeholder="请选择" v-model="dialogModels.model_CategoryID">
						<el-option label="全部分类" value="">
						</el-option>
						<el-option v-for="item in showProductModelCategory(dialogModels.productID)" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<br />
				</el-form-item>
				<el-form-item label="场景名称">
					<el-input v-model="dialogModels.sceneName"></el-input>
				</el-form-item>
				<el-form-item label="模块介绍">
					<el-input type="textarea" v-model="dialogModels.introduce" style="width: 500px;"></el-input>
				</el-form-item>
				<el-form-item label="包含考核">
					<el-switch v-model="dialogModels.isAssessment" active-color="#13ce66" inactive-color="#ff4949">
					</el-switch>
				</el-form-item>
				<el-form-item label="学情分析">
					<el-switch v-model="dialogModels.isAnalysis" active-color="#13ce66" inactive-color="#ff4949">
					</el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="outerVisible = false">取 消</el-button>
				<el-button type="primary" @click="save()">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import vueCropper2 from '@/components/vue-cropper2'

	export default {
		data() {
			return {
				//table +分页
				tableData: [],
				tableDataCount: 0,
				page_size: 10,
				page_current: 1,
				//弹出框-编辑 添加				
				outerVisible: false,
				dialogModels: {},
				dialogType: 'Add',
				//筛选条件
				productList: [],
				productID: '',
				ProductModelCategoryList: [],
				modelcategoryID: '',
				searchName: ''
			}
		},
		created() {
			this.loaddata()
		},
		components: {
			vueCropper2
		},
		methods: {
			async loaddata() {
				await this.$http.get("api/Product/GetProducts").then(res => {
					this.productList = res.data.data.filter(item => item.categoryID)
				})
				await this.$http.get('api/Product/GetProduct_Model_Categorys').then(res => {
					this.ProductModelCategoryList = res.data.data
				})
				await this.$http.get('api/Product/GetProduct_Models').then(res => {
					this.tableData = res.data.data

				})
			},
			showProductName(val) {
				let product = this.productList.find(item => {
					return item.id == val
				})
				if (product) {
					return product.name
				}
				return ''
			},
			showProductModelCategoryName(val) {
				if (val != null) {
					let productModelCategory = this.ProductModelCategoryList.find(item => {
						return item.id == val
					})
					if (productModelCategory) {
						return productModelCategory.name
					}
					return ''
				}
				return ''
			},
			showDate() {
				let _tab = this.tableData
				if (this.productID) {
					_tab = _tab.filter(item => item.productID == this.productID)

					if (this.modelcategoryID) {
						_tab = _tab.filter(item => item.model_CategoryID == this.modelcategoryID)
					}
				}

				if (this.searchName) {
					_tab = _tab.filter(item => item.modelName.search(this.searchName) > -1)
				}
				let rlist = []
				_tab.map(item => {
					rlist.push({
						id: item.id,
						modelName: item.modelName,
						sceneName: item.sceneName,
						startAddress: item.startAddress
					})
				})
				// console.log(JSON.stringify(rlist))

				this.tableDataCount = _tab.length
				return _tab.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
			},
			showProduct() {
				return this.productList.filter(item => this.tableData.map(item => item.productID).indexOf(item.id) > -1)
			},
			showProductModelCategory(id) {
				return this.ProductModelCategoryList.filter(item => item.productID == id)
			},
			upicon(e) {
				this.dialogModels.img = e;
			},
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			AddBtn() {
				this.outerVisible = true
				this.dialogType = 'Add'
				this.dialogModels = {
					id: '',
					modelName: '',
					productID: '',
					model_CategoryID: '',
					img: '',
					sceneName: '',
					startAddress: '',
					isAssessment: false,
					isAnalysis: false
				}
			},
			del(val) {
				this.$http.get('api/Product/DelProduct_Model/' + val).then(res => {
					if (res.data.code == '1') {
						this.$message({
							message: "删除成功",
							type: 'success'
						})
						this.loaddata()
					}
				})
			},
			edit(val) {
				this.dialogModels = JSON.parse(JSON.stringify(val))
				this.outerVisible = true
				this.dialogType = 'Up'
				this.dialogModels.img = this.$http.fileUrl + this.dialogModels.img
			},
			async save() {
				if (this.dialogModels.modelName == '' || this.dialogModels.modelName == null) {
					this.$message({
						message: "模块名称不能为空",
						type: 'info'
					})
				} else if (this.dialogModels.productID == '' || this.dialogModels.productID == null) {
					this.$message({
						message: "所属产品不能为空",
						type: 'info'
					})
				} 
				
				// else if (this.dialogModels.sceneName == '' || this.dialogModels.sceneName == null) {
				// 	this.$message({
				// 		message: "场景名称不能为空",
				// 		type: 'info'
				// 	})
				// } 
				
				else {

					this.dialogModels.img = this.dialogModels.img.replace(this.$http.fileUrl, '')

					//保存 产品模块 信息
					this.$http.post('api/Product/EditProduct_Model', this.dialogModels).then(res => {
						if (res.data.code == '1') {
							this.$message({
								message: "产品模块记录保存成功",
								type: 'success'
							})
							this.outerVisible = false
							this.loaddata()
						} else {
							this.$message({
								message: "产品模块记录保存失败",
								type: 'error'
							})
						}
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.product {
		.box-card {
			.el-select .el-input {
				width: 330px;
			}
		}

		.input-with-select .el-input-group__prepend {
			background-color: #fff;
		}

		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>